import {inject, injectable} from 'inversify';
import {toJS} from 'mobx';

import type {BNUserProfileUpdateParams} from '../../../../../api/types/bnrks/methods';
import type {BNUserApiModel} from '../../../../../api/types/bnrks/models';
import type {UserAdditionalDataModel} from '../UserAdditionalData.model';

import {UserAdditionalDataFactory} from '../UserAdditionalData.factory';
import {UserAdditionalDataQuestion} from '../UserAdditionalData.model';

@injectable()
export class UserAdditionalDataMapperJrpc {
  constructor(
    @inject(UserAdditionalDataFactory)
    private readonly factory: UserAdditionalDataFactory,
  ) {}

  mapDataToModel(
    apiData: UserAdditionalDataMapperJrpc.ApiData,
  ): UserAdditionalDataModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(
    apiData: UserAdditionalDataMapperJrpc.ApiData,
  ): UserAdditionalDataModel.Props {
    return {
      questions: this.questions(apiData),
    };
  }

  mapModelToDto(
    model: UserAdditionalDataModel,
  ): UserAdditionalDataMapperJrpc.Dto {
    const data = toJS(model);

    return data.questions.map(({answer, question}) => {
      return {
        answer,
        question,
      };
    });
  }

  private questions(
    apiData: UserAdditionalDataMapperJrpc.ApiData,
  ): UserAdditionalDataModel['questions'] {
    if (!apiData) {
      return [];
    }

    return Object.values(apiData).map(
      item =>
        new UserAdditionalDataQuestion({
          answer: item.answer,
          question: item.question,
        }),
    );
  }
}

export namespace UserAdditionalDataMapperJrpc {
  export type ApiData = BNUserApiModel['additional_data'];

  export type Dto = BNUserProfileUpdateParams['additional_data'];
}
